import { Branch } from '../branch';
import { Electricmeter } from '../electricmeter';
import { Additionalflat } from '../additionalflat';
export class Marketplace {
    constructor(
        public id?: number,
        public marketplaceNumber?: string,
        public name?: string,
        public keyword?: string,
        public description?: string,
        public particularities?: string,
        public street?: string,
        public zipcode?: string,
        public city?: string,
        public place?: string,
        public placeDescription?: string,
        public alternativePlace?: string,
        public sanitaryLocation?: string,
        public latitude?: string,
        public longitude?: string,
        public branchString?: string,
        public updated?: any,
        public created?: any,
        public gguid?: string,
        public branch?: Branch,
        public electricmeters?: Electricmeter,
        public additionalflats?: Additionalflat,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketplace/marketplace.model.ts